$(document).ready(function () {
    setupButtons();

    function setupButtons() {
        var btns = $('[class*=baptist-btn-]');

        $(btns).each(function () {

            if ($(this).has('span').length <= 0) {
                $(this).wrapInner("<span></span>");
            }
        });
    }
});